import mqtt from 'precompiled-mqtt';

import { REACT_APP_PW_MQTT_PASSWORD } from '../../../env';
import { getAccessToken } from '../../api-client';

let client: any = null;
const MQTT_PASSWORD = REACT_APP_PW_MQTT_PASSWORD;

const mqttConnect = (host: any, mqttOption: any) => {
  mqttOption = {
    ...mqttOption,
    keepalive: 3000,
    clean: true,
    connectTimeout: 3000, // connection timeout in 3sec
    reconnectPeriod: 3000, // will reconnect in 3sec
    clientId: `mqtt-web-client-${new Date().getTime()}`,
    password: MQTT_PASSWORD,
    username: `${getAccessToken()}-${new Date().getTime()}`,
  };
  client = mqtt.connect(host, mqttOption);
};

const mqttSub = (client: any, subscription: any, onDataReceived: any) => {
  if (client) {
    const { topic, qos } = subscription;
    client.subscribe(topic, qos, (error: any) => {
      if (error) {
        return;
      }
    });
    client.on('message', (topic: any, message: any) => {
      onDataReceived({ topic: topic, data: message });
    });
  }
};

const mqttUnSub = (client: any, subscription: any, setIsSub: any) => {
  if (client) {
    const { topic } = subscription;
    client.unsubscribe(topic, (error: any) => {
      if (error) {
        console.log('Unsubscribe error', error);
        return;
      }
      if (setIsSub) {
        setIsSub(false);
      }
    });
  }
};

const mqttDisconnect = (client: any, setConnectStatus: any) => {
  if (client) {
    client.end(() => {
      setConnectStatus('DisConnect');
    });
  }
};

const createMqttService = () => {
  return {
    get client() {
      return client;
    },
    connect: mqttConnect,
    subscribe: (subscription: any, onDataReceived: any) =>
      mqttSub(client, subscription, onDataReceived),
    unsubscribe: (subscription: any, setIsSub: any) => mqttUnSub(client, subscription, setIsSub),
    disconnect: (setConnectStatus: any) => mqttDisconnect(client, setConnectStatus),
  };
};

export default createMqttService;

export enum OPERATION {
  START = 'start',
  STOP = 'stop',
  RESULT = 'result',
  STOP_EXPIRY = 'stop_expiry',
  ATTEMPT = 'attempt',
}

export enum LIVE_CHAT_EVENTS {
  RECEIVE = 'RECEIVE',
  TRENDING = 'TRENDING',
  UPDATES = 'UPDATES',
  CONFIG = 'CONFIG',
}

export enum U_SOCKET_CONTEXT {
  POLL = 'poll',
}
